<template>
    <div>
        <a :href="urlFactory.makeCompanyCustomerMeetingsUrl(company.id.value)">
            <Card>
                <template #content>
                    <div
                        v-if="company.logoImage"
                        class="rounded-xl overflow-hidden"
                    >
                        <Image
                            class="h-36 object-cover mx-auto"
                            :src="company.logoImage.url"
                        />
                    </div>
                    <div class="mt-4 font-medium text-xl text-gray-600">
                        {{ company.displayName }}
                    </div>
                </template>
            </Card>
        </a>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import Company from '@/App/Company/Entity/Company'
    import Card from '@/Shared/Component/Card.vue'
    import Image from '@/Shared/Component/Image.vue'
    import type { PropType } from 'vue'

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
